import BarCodeScan from 'newComponents/barCodeScan'
import ExternalUrlProduct from 'newComponents/externalUrlProduct'
import FilterSearch from 'newComponents/filterSearch'
import {  useIsMobile } from 'hooks'
import styles from './styles.module.sass'


const FilterModule = (props) => {
    const {
        filters,
        initFilters,
        setFiltersActive,
        resetFilters,
        setResetFilters
    } = props

    const {isMobile} = useIsMobile()

    return(
        <div className={styles?.columnLeft}>

            {isMobile !== 'movil'
                ? <BarCodeScan />
                : <BarCodeScan />
            }
            
            <ExternalUrlProduct />
            
            <FilterSearch
                filters={filters}
                initFilters={initFilters}
                setFiltersActive={setFiltersActive}
                resetFilters={resetFilters}
                setResetFilters={setResetFilters}
            />
            
        </div>
    )
}

export default FilterModule